var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiredCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34,
    fill: "#F7F7F8",
    stroke: "#D2D5DF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1015 33.7777C40.8685 30.9397 38.1576 28.1652 34.8113 28.2288C31.2108 28.3135 28.4575 30.9821 28.4575 34.5825C28.4575 38.183 31.2108 40.8092 34.8113 40.9363C35.6373 40.9363 36.4421 40.7668 37.2257 40.4492C37.7975 38.1194 38.7506 35.9168 41.1015 33.7777ZM36.8445 44.7485H23.6287C23.6287 42.4188 20.8754 39.1572 18.5457 39.1572V30.5161C20.8754 30.5161 23.6287 26.7462 23.6287 24.4165H46.5022C46.5022 26.7462 48.7472 30.5533 51.0769 30.5533L49.6367 30.4526C51.0557 30.4738 52.4747 30.7279 53.8726 31.1938V21.875H15.75V47.29H37.6069C37.1569 45.9232 36.8434 46.1876 36.8445 44.7485Z",
    fill: "#0F205E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5188 44.0708L45.2823 42.207L40.4026 46.2734L42.4358 48.3066L47.5188 44.0708Z",
    fill: "#0F205E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7553 42.207L47.5188 40.3433L45.2823 42.207L47.5188 44.0708L49.7553 42.207Z",
    fill: "#0F205E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.635 38.1406L52.6018 36.1074L47.5188 40.3433L49.7553 42.207L54.635 38.1406Z",
    fill: "#0F205E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4358 36.1074L40.4026 38.1406L45.2823 42.207L47.5188 40.3433L42.4358 36.1074Z",
    fill: "#0F205E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6018 48.3066L54.635 46.2734L49.7553 42.207L47.5188 44.0708L52.6018 48.3066Z",
    fill: "#0F205E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiredCash);
export default __webpack_public_path__ + "static/media/tired_cash.8ed0a0339e24cbce28f7d14b12bd4b74.svg";
export { ForwardRef as ReactComponent };